import React, { useEffect } from "react";
import SideCompaniesFlow from "./SideCompaniesFlow";
import LeftSidebar from "../LeftSidebar/LeftSidebar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function MainScreen() {
    const showSuccessToast = () => {
        toast(
            <div
                id="toast-success"
                className="flex items-center w-full max-w-xs p-4 text-gray-500 bg-[#28b536] rounded-lg shadow dark:text-gray-400 dark:bg-[#28b536]"
                role="alert"
            >
                <div className="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-green-500">
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect opacity="0.3" width="24" height="24" rx="6" fill="#45185A" />
                        <path
                            d="M8.5 12.5L10.5 14.5L15.5 9.5"
                            stroke="#F1EEF6"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    <span className="sr-only">Check icon</span>
                </div>
                <div className="ms-3 text-sm font-normal text-white">
                    <span className="text-lg  block">Success</span>

                    Your integrations have been saved.
                </div>
                <button
                    type="button"
                    className="ms-auto -mx-1.5 -mb-[-1.38rem] inline-flex items-center justify-center h-8 w-8"
                    data-dismiss-target="#toast-success"
                    aria-label="Close"
                >
                    <span className="sr-only">Close</span>
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            opacity="0.6"
                            d="M10.864 1.00004L1.27539 11M1.27535 1L10.8639 11"
                            stroke="#DDD6ED"
                            stroke-width="1.5"
                            stroke-linecap="round"
                        />
                    </svg>
                </button>
            </div>
            ,
            {
                onOpen: () => {
                    setTimeout(() => {
                        localStorage.removeItem('isUserOnboardingDone');
                    }, 500)
                },
                position: "top-right",
                autoClose: 3000, // Closes in 3 seconds
                closeOnClick: true,
                hideProgressBar: true,
                closeButton: false, // Remove the default close button
            }
        );

    };

    useEffect(() => {
        if (localStorage.getItem("isUserOnboardingDone")) {
            showSuccessToast();
        } else {
        }
    }, []);
    return (
        <>
            <style>
                {`
             .Toastify__toast-theme--light {
    background: transparent !important;
    box-shadow: none !important;
}
    .ms-3.text-sm.font-normal.text-white{
    width: 230px !important;
    }
    div#toast-success{
    width: 360px !important;
    }
                `}
            </style>

            <div className="max-w-8xl mx-auto grid grid-cols-1 lg:grid-cols-8">
                <LeftSidebar />
                <div className="lg:col-span-7 lg:px-8 lg:pr-[3.5rem]">
                    <SideCompaniesFlow />
                </div>
                <ToastContainer />
            </div></>

    );
}

export default MainScreen;

